import React from 'react';
import Helmet from 'react-helmet';

import { IMGIX_URL, READER_URL } from '@src/env';
import { normalizeUrl } from '@utils/url_validations';

export enum TwitterCards {
  SummaryLargeImage = 'summary_large_image',
  Summary = 'summary',
}

const DEFAULT_TITLE = 'The Information';
const DEFAULT_IMAGE_PATH = `${IMGIX_URL}/global/defaults/article_image_unavailable.jpg`;

interface MetaTagsProps {
  title?: string;
  description: string;
  canonicalPath?: string;
  ogImagePath?: string;
  ogDescription?: string;
  ogTitle?: string;
  twitterDescription?: string;
  twitterTitle?: string;
  twitterCard?: TwitterCards;
  ogSiteName?: string;
}

const MetaTags = ({
  description,
  title = DEFAULT_TITLE,
  canonicalPath,
  ogImagePath = DEFAULT_IMAGE_PATH,
  ogDescription = description,
  ogTitle = title,
  ogSiteName = title,
  twitterDescription = description,
  twitterTitle = title,
  twitterCard = TwitterCards.SummaryLargeImage,
}: MetaTagsProps) => {
  const canonicalUrl = `${READER_URL}${canonicalPath}`;
  const baseUrl = typeof window !== 'undefined' ? normalizeUrl(window.location.href) : '';

  return (
    <Helmet>
      <title>{title}</title>
      {canonicalUrl && <base href={baseUrl} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta property="og:image" content={`${IMGIX_URL}${ogImagePath}`} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
    </Helmet>
  );
};

export default MetaTags;
